import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import { ShopOrder } from '@models';

export class Offer {
	id: number;
	contact_id: number;
	subject: string;
	valid_until: string;
	valid_until_date: NgbDateStruct;
	mail_sent: boolean;
	billing_address: string;
	billing_zipcode: string;
	billing_city: string;
	billing_province_id: string;
	billing_country_id: string;
	delivery_address: string;
	delivery_zipcode: string;
	delivery_city: string;
	delivery_province_id: string;
	delivery_country_id: string;
	show_total: boolean;
	comments: string;
	user_created_id: number;
	user_modified_id: number;
	created_at: string;
	updated_at: string;

	offer_completed: boolean;
	order_invoice: string;
	order: ShopOrder;

	contact: string;
	company: string;
	user_created: string;
	user_modified: string;
}



// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/models/crm/offer.ts